import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { PageScrollView } from 'components/Page';
import React from 'react';
import { Txt } from 'components/Txt';
import { useDispatch } from 'react-redux';
import { Card } from 'components/Card';
import { TextAreaField } from 'components/Field/TextAreaField/TextAreaField';
import {
  doEngageScheduledVisitCancel,
  NAVIGATE_MODAL_BACK,
} from 'store/actions';
import { theme } from 'lib/theme';

export const EngageCancelScheduledVisitModal: React.FC<
  ModalScreenProps<ModalScreens.EngageCancelScheduledVisit>
> = (props) => {
  const { propertyId, pageKey, scheduledVisitId } = props.route.params;
  const dispatch = useDispatch();

  const [note, setNote] = React.useState('');

  const handleClose = React.useCallback(() => {
    dispatch(NAVIGATE_MODAL_BACK());
  }, [dispatch]);

  const handleSave = () =>
    dispatch(
      doEngageScheduledVisitCancel({
        propertyId,
        pageKey,
        scheduledVisitId: scheduledVisitId,
        cancelledReason: note.trim(),
      }),
    );

  return (
    <PageScrollView
      header={
        <NavigationHeader
          onPressCancelButton={handleClose}
          onPressSaveButton={note.trim() ? handleSave : null}
          saveButtonText="Confirm"
          heading="Cancel Scheduled Visit"
        />
      }
    >
      <Card
        label="Reason"
        explanation="Please provide a reason for cancellation. This will be included in the cancellation email to contacts."
      >
        <TextAreaField
          // Blank as per ticket
          placeholder=""
          onChange={setNote}
          value={note}
          onEsc={handleClose}
          maxLength={1000}
        />
      </Card>

      <Txt
        style={{
          color: theme.colors.orange,
          paddingHorizontal: theme.paddingHorizontal * 2,
        }}
      >
        Warning: Cancelling a scheduled visit is a non-recoverable action.
      </Txt>
    </PageScrollView>
  );
};
